import { useEffect, useState, useContext } from "react"
import { QuoteContext } from "../context/context"

// Utility functions
import { buildQuotePDF, pdfBytesToBase64 } from "./pdf-utils/build-quote-pdf"

// UI components
import { CheckIcon, LinkIcon, TrashIcon } from "../../../utils/svgs-v2"
import Loading from "../../../components/app/loading/loading"

// Returns the markup for an option now
export default function ConfirmedPackage({ quoteID, details, onDelete, customIntroduction, replaceFields, offsetYear, alternativePricing = null }) {
	const [loading, setLoading] = useState(true)
	const [documentURL, setDocumentURL] = useState("")

	// Pull the update method from the quote context
	const { ctxSavePDFLink, ctxClientFirstName, ctxClientLastName, ctxDepositValue } = useContext(QuoteContext)

	// On component mount, start processing the generation immediately when a quoteID is ready
	useEffect(() => {
		// If we have the quoteID is present in the props
		if (quoteID && quoteID.length > 0) {
			generatePDFQuote()
		}
	}, [quoteID])

	// Process the generation of the PDF quote. The render/upload itself lives in
	// the shared buildQuotePDF builder so it can be reused outside this wizard
	// (e.g. the post-generation tee-time editor); this component just wires it
	// to the quote context.
	const generatePDFQuote = async () => {
		// Build, upload and return the PDF for this completed package
		const { url, bytes } = await buildQuotePDF({
			quoteID,
			details,
			clientName: `${ctxClientFirstName} ${ctxClientLastName}`,
			customIntroduction,
			replaceFields,
			offsetYear,
			customDeposit: ctxDepositValue,
			alternativePricing,
		})

		// Write the new document into a base64 for embedding onto the email
		const documentAsBase64 = await pdfBytesToBase64(bytes)

		// Set the state and update the package in the quote context
		setLoading(false)
		setDocumentURL(url)
		ctxSavePDFLink(details._id, url, documentAsBase64)
	}

	return (
		<div className="quote-option-row">
			<div className="quote-option-row-title quote-option-pdf-title">
				{details.reference}

				{!loading && <CheckIcon />}
			</div>

			{loading && (
				<div className="">
					<Loading hideLabel={true} />
				</div>
			)}

			{!loading && (
				<div className="quote-options-end-actions">
					<a
						className="quote-option-end-action"
						href={documentURL}
						target="_blank"
						rel="noreferrer">
						<LinkIcon />
					</a>

					<div
						className="quote-option-end-action"
						onClick={() => onDelete()}>
						<TrashIcon />
					</div>
				</div>
			)}
		</div>
	)
}
